import { useCallback, useMemo, useState } from 'react'

export type ListSelection = {
  selected: ReadonlySet<string>
  onToggle: (id: string) => void
  onToggleAll: (ids: string[], checked: boolean) => void
}

export function useListSelection() {
  const [selected, setSelected] = useState<ReadonlySet<string>>(new Set())

  const onToggle = useCallback((id: string) => {
    setSelected((prev) => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id)
      else next.add(id)
      return next
    })
  }, [])

  const onToggleAll = useCallback((ids: string[], checked: boolean) => {
    setSelected((prev) => {
      const next = new Set(prev)
      for (const id of ids) {
        if (checked) next.add(id)
        else next.delete(id)
      }
      return next
    })
  }, [])

  const clear = useCallback(() => setSelected(new Set()), [])

  const selection = useMemo<ListSelection>(
    () => ({ selected, onToggle, onToggleAll }),
    [selected, onToggle, onToggleAll],
  )

  return { selection, selectedIds: useMemo(() => [...selected], [selected]), clear }
}
